export default {
  buildType: 'prod',
  serverEndpoint: 'https://api.wagons.cn',
  openinstallAppKey: 'r62z2q',
  jdPrefix: 'https://opencredit.jd.com',
};
